/* eslint-disable jsx-a11y/media-has-caption */
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';
import gridStyles from 'src/shared/theme/grid.module.scss';
import RoundedButton from 'src/shared/components/RoundedButton';
import ReactPlayer from 'react-player';
import { useInView } from 'react-intersection-observer';
import Image from 'src/shared/components/Image';

interface Props {
    type: 'header' | 'rightMedia' | 'leftMedia';
    videoUrl?: string;
    imgUrl?: string;
    title: string;
    description: string | React.ReactNode;
    buttonText: string;
    onClick?: () => void;
}

const IntroductionWithMedia = (props: Props) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const [ref, inView] = useInView({ threshold: 0.1 });

    const onEnded = () => {
        setIsPlaying(false);
        setTimeout(() => {
            setIsPlaying(true);
        }, 100);
    };

    useEffect(() => {
        if (inView && !isPlaying) {
            setTimeout(() => setIsPlaying(true), 500);
        }
    }, [inView, isPlaying]);

    return (
        <div
            className={classnames(gridStyles.container, styles.container, {
                [styles.header]: props.type === 'header',
                [styles.rightMedia]: props.type === 'rightMedia',
                [styles.leftMedia]: props.type === 'leftMedia',
            })}
        >
            <div className={`${gridStyles.xl6} ${gridStyles.lg12}`}>
                <div className={styles.section}>
                    <div className={styles.content}>
                        <p className={styles.title}>{props.title}</p>
                        <p className={styles.description}>{props.description}</p>
                    </div>
                    <RoundedButton
                        type={props.type === 'header' ? 'white' : 'transparent-on-dark'}
                        className={styles.viewButton}
                        onClick={props.onClick}
                    >
                        {props.buttonText}
                    </RoundedButton>
                </div>
            </div>
            <div className={`${gridStyles.xl6} ${gridStyles.lg12}`} ref={ref}>
                {props.videoUrl && (
                    <ReactPlayer width="100%" playing={isPlaying} loop playsinline autoPlay muted url={props.videoUrl} onEnded={onEnded} />
                )}
                {props.imgUrl && <Image src={props.imgUrl} width="100%" />}
            </div>
        </div>
    );
};

IntroductionWithMedia.defaultProps = {
    videoUrl: '',
    imgUrl: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick: () => {},
};

export default IntroductionWithMedia;
